import { OrganizationSSOPage as Page } from "../features/organization-sso";

export function OrganizationSSOPage() {
  return <Page />;
}
